module.exports = __webpack_public_path__ + "img/et.668a4bc4.svg";